var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"view__404"},[_c('ui-card',{attrs:{"padding":3}},[_c('h1',[_vm._v("🤔 404")]),_c('h2',[_vm._v(_vm._s(_vm.$t('title')))]),_c('p',[_vm._v(_vm._s(_vm.$t('description')))]),_c('p',[_c('router-link',{attrs:{"to":_vm.backlink}},[_vm._v(_vm._s(_vm.$t('link')))])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }